import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  IconButton,
  Typography,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info'; // Import the icon you need
import { ReactComponent as CloseIcon } from '../../assets/images/car/car-delete-icon.svg';

const AlertDialog = ({
  open,
  title = 'הודעה',
  message,
  onClose,
  onConfirm,
  type = 'alert',
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      // Mount dialog into dedicated portal root so translators won't move it
      container={
        typeof document !== 'undefined'
          ? document.getElementById('mui-portal-root') || undefined
          : undefined
      }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        style: {
          width: '500px', // Set your desired width
          borderRadius: '16px', // Add border radius here
        },
        // Prevent translators from modifying the dialog content
        translate: 'no',
        className: 'notranslate',
      }}
      sx={{
        width: '400px',
        maxWidth: '90%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 'auto', // Center horizontally
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: 'absolute',
          top: '10px',
          left: '10px',
          color: 'black', // Close button color
          zIndex: 1, // Ensure the close button is on top
        }}
      >
        <CloseIcon />
      </IconButton>

      <Typography
        variant="body1"
        justifyItems={'center'}
        align="center"
        fontSize="25px"
        marginTop="25px"
        fontWeight="bold"
        color="initial"
      >
        {' '}
        {title}{' '}
      </Typography>

      <DialogContent
        sx={{
          //   width: '450px',
          maxWidth: '95%',
          display: 'flex',
          alignItems: 'center',
          margin: 'auto',
        }}
      >
        <Typography
          marginTop="25px"
          fontSize="20px"
          justifyItems={'center'}
          align="center"
          variant="p"
        >
          {' '}
          {message}
        </Typography>{' '}
        {/* Title as h1 */}
      </DialogContent>
      <DialogActions
        sx={{ gap: '16px', justifyContent: 'center', paddingBottom: '24px' }}
      >
        {type === 'alert' && (
          <>
            <Button
              sx={{
                background: '#fff',
                border: '1px solid rgba(45, 186, 193, 1)',
                color: 'rgba(1, 77, 108, 1)', // White font color
                borderRadius: '8px', // Rounded corners
                padding: '8px 16px', // Button padding
                '&:hover': {
                  background: '#4BBAC5', // Hover background gradient
                },
                // Optionally add box-shadow to improve button visibility on hover
                '&:focus': {
                  boxShadow: '0 0 5px rgba(0, 0, 0, 0.2)',
                },
              }}
              onClick={onClose}
              color="secondary"
            >
              אישור
            </Button>
          </>
        )}

        {type === 'confirm' && (
          <>
            <Button
              sx={{
                background: '#fff',
                border: '1px solid rgba(45, 186, 193, 1)',
                color: 'rgba(1, 77, 108, 1)',
                borderRadius: '8px',
                padding: '8px 16px',
                '&:hover': {
                  background: '#4BBAC5',
                },
              }}
              onClick={onConfirm}
            >
              אישור
            </Button>
            <Button
              sx={{
                background: '#fff',
                border: '1px solid rgba(192, 211, 218, 1)',
                color: 'rgba(1, 77, 108, 1)',
                borderRadius: '8px',
                padding: '8px 16px',
                '&:hover': {
                  background: '#e0e0e0',
                },
              }}
              onClick={onClose}
            >
              ביטול
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AlertDialog;
